var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('div',{staticClass:"page-a4 container elevation-5",attrs:{"size":"A4","layout":"landscape"}},_vm._l((_vm.prototypeData),function(prototype){return _c('div',{key:prototype.id},[(_vm.isNewData(prototype))?_c('manufac-for-export-new',{attrs:{"prototype":prototype}}):_c('manufac-for-export',{attrs:{"prototype":prototype}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }